import { ScheduleAlertAction } from '@app/components/Alerts/ScheduleInstallationAlert';
import { SelectedDate } from '@app/hooks';

import { ScheduleInput } from '@mfe/shared/schema-types';

export const computeValidationMessage = (selectedDate: SelectedDate, selectedInterval: ScheduleInput | null) => {
  if (!selectedDate.day) {
    return ScheduleAlertAction.DateAndTimeRequired;
  }

  if (!selectedInterval?.from) {
    return ScheduleAlertAction.TimeRequired;
  }

  return ScheduleAlertAction.DateAndTimeConfirmed;
};
